import { atom } from 'jotai';

/**
 * Target session for agent-driven recording, or ``null`` for "no override".
 *
 * The recorder is a single-active-session global keyed off
 * ``useCurrentSessionId()`` (the route). When the agent drives recording from a
 * surface that is NOT the session page (e.g. the projects/agent chat), there is
 * no route session, so the {@link AgentSessionRecordingControl} sets this to the
 * session it is acting on. ``useRecordingSessionId()`` prefers it over the route
 * id, binding the recording engine to that session for the duration of the
 * agent-driven recording.
 *
 * Default ``null`` — when unset, recording behaves exactly as before (route
 * session only). Set on start/pause/resume, cleared when recording fully stops.
 */
export const agentRecordingSessionIdAtom = atom<string | null>(null);
